// Import the State
import store from "@/store";

// Layout
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Layout/AuthLayout.vue";

// General
import NotFound from "@/pages/General/NotFound.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

//
import Sandbox from "@/pages/Sandbox/Sandbox.vue";

// User
import User from "@/pages/User/UserProfile.vue";
import Login from "@/pages/User/Login.vue";
import ForgotPassword from "@/pages/User/ForgotPassword.vue";
import ResetPassword from "@/pages/User/ResetPassword.vue";
import Unauthorised from "@/pages/Auth/Unauthorised.vue";
import Lock from "@/pages/User/Lock.vue";

// Customers
import CustomerDefault from "@/pages/Customer/CustomerDefault";
import CustomerProfile from "@/pages/Customer/CustomerProfile";

// Tours
import TourDefault from "@/pages/Tour/TourDefault";
import TourProfile from "@/pages/Tour/TourProfile";

// Tour Assets
import RestaurantDefault from "@/pages/TourAssets/RestaurantDefault";
import VendorDefault from "@/pages/TourAssets/VendorDefault";
import StaffDefault from "@/pages/TourAssets/StaffDefault";
import AccomDefault from "@/pages/TourAssets/AccomDefault";
import SupplierDefault from "@/pages/TourAssets/SupplierDefault";
import ExtraDefault from "@/pages/TourAssets/ExtraDefault";
import GuideDefault from "@/pages/TourAssets/GuideDefault";
import DiscountDefault from "@/pages/TourAssets/Discount/DiscountDefault";

//Departures
import DepartureDefault from "@/pages/Tour/Departures/DepartureDefault";
import DepartureProfile from "@/pages/Tour/Departures/DepartureProfile";
import DepartureManifest from "@/pages/Tour/Departures/DepartureManifest";
import DepartureData from "@/pages/Tour/Departures/DepartureData";

// Bookings
import BookingDefault from "@/pages/Booking/BookingDefault";
import BookingProfile from "@/pages/Booking/BookingProfile";

// Enquiries
import EnquiryDefault from "@/pages/Enquiry/Dashboard/EnquiryDefault";
import EnquiryOverview from "@/pages/Enquiry/Dashboard/EnquiryOverview";

// Reorts
import ReportDefault from "@/pages/Reporting/ReportDefault";
import ReportSales from "@/pages/Reporting/ReportSales";
import ReportDepartures from "@/pages/Reporting/ReportDepartures";
import ReportOverdue from "@/pages/Reporting/ReportOverdue";
import sandbox from "../services/api/sandbox";

// Authentication Route Guards
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
  } else {
    next("/");
  }
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
  } else {
    next("/login");
  }
};

let authMenu = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: ifNotAuthenticated,
      meta: {
        guestAccess: true
      }
    },
    {
      path: "/forgot_password",
      name: "Forgot Password",
      component: ForgotPassword,
      beforeEnter: ifNotAuthenticated,
      meta: {
        guestAccess: true
      }
    },
    {
      path: "/reset_password",
      name: "Reset Password",
      component: ResetPassword,
      beforeEnter: ifNotAuthenticated,
      meta: {
        guestAccess: true
      }
    }
  ]
};

let userMenu = {
  path: "/user",
  component: DashboardLayout,
  meta: {
    permissions: ["crm.route.user"]
  },
  children: [
    {
      path: "profile",
      name: "User Profile",
      components: { default: User },
      meta: {
        permissions: ["crm.route.user.profile"]
      }
    }
  ]
};

let customerMenu = {
  path: "/customer",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Customer Management",
      components: { default: CustomerDefault },
      meta: {
        permissions: ["crm.route.customer"]
      }
    },
    {
      path: ":id",
      name: "Customer Profile",
      component: CustomerProfile,
      props: true,
      meta: {
        permissions: ["crm.route.customer.profile"]
      }
    }
  ]
};

let bookingMenu = {
  path: "/booking",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Booking Management",
      component: BookingDefault,
      meta: {
        permissions: ["crm.route.booking"]
      }
    },
    {
      path: ":id",
      name: "Booking Profile",
      component: BookingProfile,
      props: true,
      meta: {
        permissions: ["crm.route.booking.profile"]
      }
    }
  ]
};

let tourMenu = {
  path: "/tour",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Adventure Management",
      component: TourDefault,
      meta: {
        permissions: ["crm.route.tour"]
      }
    },
    {
      path: "discounts",
      name: "Discount Management",
      component: DiscountDefault,
      meta: {
        permissions: ["crm.route.tour.discount"]
      }
    },
    {
      path: "restaurants",
      name: "Restaurant Management",
      component: RestaurantDefault,
      meta: {
        permissions: ["crm.route.tour.restaurant"]
      }
    },
    {
      path: "vendors",
      name: "Vendor Management",
      component: VendorDefault,
      meta: {
        permissions: ["crm.route.tour.vendor"]
      }
    },
    {
      path: "staff",
      name: "Staff Management",
      component: StaffDefault,
      meta: {
        permissions: ["crm.route.tour.staff"]
      }
    },
    {
      path: "accoms",
      name: "Accommodation Management",
      component: AccomDefault,
      meta: {
        permissions: ["crm.route.tour.accommodation"]
      }
    },
    {
      path: "suppliers",
      name: "Partner Management",
      component: SupplierDefault,
      meta: {
        permissions: ["crm.route.tour.supplier"]
      }
    },
    {
      path: "extras",
      name: "Extra Management",
      component: ExtraDefault,
      meta: {
        permissions: ["crm.route.tour.extra"]
      }
    },
    {
      path: "guides",
      name: "Guide Management",
      component: GuideDefault,
      meta: {
        permissions: ["crm.route.tour.guide"]
      }
    },
    {
      path: ":tour_id",
      name: "Adventure Profile",
      component: TourProfile,
      props: true,
      meta: {
        permissions: ["crm.route.tour.profile"]
      }
    },
    {
      path: ":tour_id/departure/:departure_id",
      component: DepartureProfile,
      props: true,
      children: [
        {
          path: "",
          name: "Departure Profile",
          component: DepartureData,
          meta: {
            permissions: ["crm.route.tour.departure.profile"]
          }
        },
        {
          path: "manifest",
          name: "Departure Manifest",
          component: DepartureManifest,
          meta: {
            permissions: ["crm.route.tour.departure.manifest"]
          }
        }
      ]
    }
  ]
};

let dashboardMenu = {
  path: "/",
  component: DashboardLayout,
  redirect: "/dashboard",
  children: [
    {
      path: "dashboard",
      name: "Dashboard",
      components: { default: Dashboard },
      meta: {
        permissions: ["crm.route.dashboard"]
      }
    },
    {
      path: "sandbox",
      name: "Sandbox",
      component: Sandbox,
      meta: {}
    },
    {
      path: "unauthorised",
      name: "Access Error",
      component: Unauthorised,
      meta: {}
    }
  ]
};

let enquiryMenu = {
  path: "/enquiry",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Enquiry Management",
      component: EnquiryDefault,
      meta: {
        permissions: ["crm.route.enquiry"]
      }
    },
    {
      path: ":id",
      name: "Enquiry Overview",
      component: EnquiryOverview,
      props: true,
      meta: {
        permissions: ["crm.route.enquiry.profile"]
      }
    }
  ]
};

let reportsMenu = {
  path: "/reports",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "Reporting",
      component: ReportDefault,
      meta: {
        permissions: ["crm.route.reports"]
      },
      children: [
        {
          path: "sales",
          component: ReportSales,
          meta: {
            permissions: ["crm.route.reports.sales"]
          }
        },
        {
          path: "departures",
          component: ReportDepartures,
          meta: {
            permissions: ["crm.route.reports.departures"]
          }
        },
        {
          path: "overdue",
          component: ReportOverdue,
          meta: {
            permissions: ["crm.route.reports.overdue"]
          }
        }
      ]
    }
  ]
};

const routes = [
  dashboardMenu,
  customerMenu,
  enquiryMenu,
  bookingMenu,
  tourMenu,
  userMenu,
  authMenu,
  reportsMenu,
  {
    path: "*",
    component: NotFound,
    name: "NotFound"
  }
];

export default routes;
